import * as Common from '@/components/common';

import Vue from 'vue'
Object.keys(Common).map(k=> {
  Vue.component(k, Common[k]);
})